if (!customElements.get('np-image-variant')) {
  customElements.define('np-image-variant', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select[data-variant-input]');
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.rows = [...this.querySelectorAll('button[data-value]')];
      if (!this.select || !this.details || !this.rows.length) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', e => {
        const row = e.target.closest('button[data-value]');
        if (!row || row.disabled) return;
        this.select.value = row.dataset.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
        this.details.open = false;
        this.summary.focus();
      }, { signal });
      this.select.addEventListener('change', () => queueMicrotask(() => this.sync()), { signal });
      this.closest('.product-section')?.addEventListener('variantChange', () => queueMicrotask(() => this.sync()), { signal });
      document.addEventListener('pointerdown', e => {
        if (!this.contains(e.target)) this.details.open = false;
      }, { signal });
      this.addEventListener('focusout', e => {
        if (!this.contains(e.relatedTarget)) this.details.open = false;
      }, { signal });
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.details.open = false; this.summary.focus(); e.preventDefault(); }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return;
        const rows = this.rows.filter(row => !row.disabled);
        if (!rows.length) return;
        e.preventDefault(); this.details.open = true;
        const index = rows.indexOf(document.activeElement);
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (index + 1) % rows.length : (index <= 0 ? rows.length - 1 : index - 1);
        rows[next].focus();
      }, { signal });
      const heading = document.createElement('span');
      heading.className = 'np-image-variant__heading';
      heading.textContent = this.querySelector('.variant__label')?.textContent.trim() || 'カラー';
      this.querySelector('.np-image-variant__heading')?.remove();
      this.insertBefore(heading, this.details);
      this.sync(); this.setAttribute('data-ready', '');
    }
    sync() {
      if (!this.isConnected) return;
      this.rows.forEach(row => {
        const option = [...this.select.options].find(o => o.value === row.dataset.value);
        row.disabled = !option || option.disabled;
        const selected = row.dataset.value === this.select.value;
        row.setAttribute('aria-pressed', String(selected));
        if (!selected) return;
        this.querySelector('[data-selected-label]').textContent = row.querySelector('span').textContent;
        this.summary.setAttribute('aria-label', `${this.querySelector('.variant__label')?.textContent.trim() || 'カラー'}：${row.dataset.value}を選択中`);
        const source = row.querySelector('img');
        const image = this.querySelector('[data-selected-image]');
        image.hidden = !source;
        if (source) image.src = source.src;
        else image.removeAttribute('src');
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
